<template>
   <div class="video-input">
      <div class="form-group" v-if="showButton">
         <button type="button" class="btn btn-default" @click="showModal()">Choose Video</button>
      </div>
      <video-player v-if="value !== null && showVideo" :id="value"></video-player>
      <div class="modal fade" tabindex="-1" role="dialog">
         <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
               <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                  <h4 class="modal-title">Choose Video</h4>
               </div>
               <div class="modal-body">
                  <div class="row">
                     <div class="col-sm-6 video-list">
                        <div :class="'well clickable media ' + ((selected == video.id)?' selected':'')" v-for="video in videos" @click="select(video.id)">
                           <div class="media-left">
                              <img class="media-object" :src="video.thumbnail" style="width: 64px"/>
                           </div>
                           <div class="media-body">
                              <h4 class="media-heading">{{video.title}}</h4>
                           </div>
                        </div>
                     </div>
                     <div class="col-sm-6" v-if="selected !== null">
                        <video-player :id="selected"></video-player>
                     </div>
                  </div>
               </div>
               <div class="modal-footer">
                  <label class="btn btn-success pull-left" v-if="!uploading"><input type="file" @change="uploadFile" style="width:0;height:0"/>Upload</label>
                  <label class="btn btn-default pull-left" v-else>Video is uploading... <i class="fa fa-spinner fa-spin"></i></label>

                  <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
                  <button type="button" class="btn btn-primary" :disabled="selected === null" @click="choose(selected)">Choose</button>
               </div>
            </div><!-- /.modal-content -->
         </div><!-- /.modal-dialog -->
      </div><!-- /.modal -->
   </div>
</template>

<script>
    export default {
        name: 'video-input',
        props: {
            value: {default: null},
            'showmodal': {default: false},
            showButton: {default: true},
            showVideo: {default: true},
        },
        data() {
            return {
                videos: [],
                selected: null,
                uploading: false,
            };
        },
        watch: {
            'showmodal': function(newVal) {
                if(newVal)
                {
                    this.showModal();
                }
            }
        },
        methods: {
            showModal() {
                $(this.$el).find('.modal').modal('show');
            },
            hideModal() {
                $(this.$el).find('.modal').modal('hide');
            },
            uploadFile(e) {
                let files = e.target.files;

                if(files.length > 0)
                {
                    let formData = new FormData();
                    formData.append('file', files[0], files[0].name);
                    this.uploading = true;
                    this.$http.post('/api/video', formData).then(response => {
                        if(response.data.success)
                        {
                            this.select(response.data.video_id);
                            this.refresh();
                        }
                        else
                        {
                            this.$notify(response.data.error, 'danger');
                        }
                        this.uploading = false;
                    });
                }
            },
            refresh() {
                this.$http.get('/api/video').then(response => {
                    this.videos = response.data.videos;
                });
            },
            select(id) {
                this.selected = id;
            },
            choose(id) {
                this.$emit('input', id);
                this.hideModal();
            }
        },
        mounted() {
            this.select(this.value);
            this.refresh();
        },
    }
</script>

<style>
   .video-input .well.selected {
      background-color: #00588d;
   }

   .video-input .well.selected .media-heading {
      color: #fff;
   }

   .video-input .video-list {
      height: 400px;
      overflow-y: auto;
   }
</style>
